import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { LogoFont } from './styles';

const StyledLogoLink = styled.a`
  text-decoration: none;
  padding: 10px;
  margin-left: -10px;
`;

export const NavLogo: React.FC = () => {
  return (
    <Link to="/" component={StyledLogoLink}>
      <LogoFont style={{ fontSize: '40px' }}>DUBHACKS</LogoFont>
    </Link>
  );
};
